import theme from '../utils/themes/theme';
export const defaultIconProps = {
    primaryColor: theme.colors.bg.dark,
    secondaryColor: theme.colors.bg.darkGray,
    width: 16,
    height: 16,
};
